import {
  AlignType,
  ETextStyleVariant,
  GeneralManageVehiclesOutlineIcon,
  GeneralMapPinOutlineIcon,
  Selector,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useSearchModes } from '@/hooks/useSearchModes';
import { getQueryParams } from '@/redux/selectors/queryParams';
import { isDeliveryModeFromParams } from '@/utility/queryParams';

interface IModeSwitcherContentProps {
  open?: boolean;
  onModeSelect?: () => void;
}

const ModeSwitcherContent: React.FC<IModeSwitcherContentProps> = ({ open, onModeSelect }) => {
  const intl = useIntl();
  const { handleModeSelect } = useSearchModes(onModeSelect);
  const queryParams = useSelector(getQueryParams);

  const isDeliveryMode = isDeliveryModeFromParams(queryParams);

  if (!open) {
    return null;
  }

  return (
    <div className="flex gap-3">
      {/* Rentals mode */}
      <Selector
        alignVariant={AlignType.VerticalLeft}
        ariaLabel="Rentals mode"
        className="flex-1"
        description={intl.formatMessage({
          defaultMessage: 'RVs to drive or tow',
          id: 'Jy3eQB',
          description: 'Rentals mode description',
        })}
        descriptionClassName="text-gray-50"
        contentWrapperClassName="!py-3 !px-4"
        icon={GeneralManageVehiclesOutlineIcon}
        isSelected={!isDeliveryMode}
        label={intl.formatMessage({
          defaultMessage: 'Drivable RVs',
          id: 'Ef4SpN',
          description: 'Rentals mode option',
        })}
        labelVariant={ETextStyleVariant.MediumBold}
        labelClassName="pt-6"
        name="rentals-mode"
        onChange={() => handleModeSelect(false)}
        value="rentals"
        withBorder
      />

      {/* Delivery Mode */}
      <Selector
        alignVariant={AlignType.VerticalLeft}
        ariaLabel="Delivery mode"
        className="flex-1"
        contentWrapperClassName="!py-3 !px-4"
        description={intl.formatMessage({
          defaultMessage: 'Ready-to-stay RVs',
          id: 'oGDsjD',
          description: 'Delivery mode description',
        })}
        descriptionClassName="text-gray-50"
        icon={GeneralMapPinOutlineIcon}
        isSelected={isDeliveryMode}
        label={intl.formatMessage({
          defaultMessage: 'Stationary RVs',
          id: 'THrE/J',
          description: 'Delivery mode option',
        })}
        labelVariant={ETextStyleVariant.MediumBold}
        labelClassName="pt-6"
        name="delivery-mode"
        onChange={() => handleModeSelect(true)}
        value="delivery"
        withBorder
      />
    </div>
  );
};

export default ModeSwitcherContent;
